export default "__VITE_ASSET__BichhQku__"